var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"video"}},[_c('v-container',{staticClass:"text-center"},[_c('div',{staticClass:"error--text text--darken-3 font-weight-bold mb-8 text-h4 text-sm-h3",attrs:{"data-aos-duration":"1500","data-aos":"fade-down"}},[_vm._v(" الفيديو الاعلاني ")]),_c('div',{staticClass:"video"},[_c('video',{attrs:{"controls":"","width":_vm.$vuetify.breakpoint.mdAndUp
            ? 800
            : _vm.$vuetify.breakpoint.smOnly
            ? 500
            : 300}},[_c('source',{attrs:{"src":require("@/assets/imgs/CVideo.mp4"),"type":"video/mp4"}}),_vm._v(" Your browser does not support HTML video. ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }